import React from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { authService } from "../../../auth";
import { connect } from "react-redux";
import ProjectLatestPostList from "./ProjectLatestPostList";
import ProjectPhotosPostList from "./ProjectPhotosPostList";
import ProjectVideoPostList from "./ProjectVideoPostList";
import ProjectArticlePostList from "./ProjectArticlePostList";
import ProjectAudioPostList from "./ProjectAudioPostList";
import axios from "axios";
import alertPopUp from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from "react-router-dom";

const ErorrMsgPopUp = withReactContent(alertPopUp);

class ProjectPostNavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postCreationResponse: this.props.postCreationResponse,
            activeKey: "latest_1",
            latestTabKey: "latest_1",
            photosTabKey: "photos_1",
            videosTabKey: "videos_1",
            articlesTabKey: "articles_1",
            audioTabKey: "audio_1",
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated(),
            requestLogin: false,
            circleAdminList: [],
            participantList: []
        };
    }

    componentDidMount() {
        window.$(".posthnavtab").sticky({ topSpacing: 109, responsiveWidth: true });
        this.getProjectDetails();
        this.getCircleAdminList();
        //this.getUserConfig();
    }

    getProjectDetails() {
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_userServiceURL}/backend/participation/get-participant-list/${this.props.projectId}` ,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                this.setState({participantList : response.data.body});
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    getCircleAdminList() {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_userServiceURL}/backend/circle/getCircleMember/${this.props.projectId}`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.message === 'Success!') {
                this.setState({ circleAdminList: response.data.body });
            }
        })
        .catch((err) => {
            console.log(err);
        });
    }

    componentWillReceiveProps(props) {
        if (props.postCreationResponse !== undefined) {
            let tabKey = this.state.activeKey;
            let value = tabKey.split("_");
            let tabKeyProp = value[0] + "TabKey";
            let tabKeyVal = value[0] + "_" + (parseInt(value[1]) + 1);
            this.setState({
                postCreationResponse: props.postCreationResponse,
                [tabKeyProp]: tabKeyVal,
                activeKey: tabKeyVal,
            });
        }
    }

    requestLogin() {
        this.setState({ requestLogin: true });
        window.$("#loginModal").modal("show");
    }

    handleTabSelect = (tabKey) => {
        this.setState({
            activeKey: tabKey,
        });
    };

    getUserConfig = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/circle/get/user/config/' + this.props.projectId + '/' + this.state.userData.userId,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res && res.status === '200 OK') {
                this.setState({
                    userConfigData: res.body
                })
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    checkPostDataConfig = () => {
        if ((this.props.project && (this.props.project && this.props.project.creatorUserId === this.state.userData.userId || this.props.project.userId === this.state.userData.userId || this.state.circleAdminList?.includes(this.state.userData.userId) ||
            (this.state.participantList?.includes(this.state.userData.userId) && this.props?.project?.project?.projectParticipantPermission?.post) || this.props.project && (this.props.project.companyIds && this.props.project.companyIds.includes(this.props.project.creatorUserId)) || this.props.project.editPermission))) {
            window.$("#addpostpop").modal("show");
        } else {
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then(() => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <p>{"Only participants can post in Project. Connect with project admin to join this project."}</p>,
                })
            })
        }
    }

    render() {
        return (
            <Tab.Container
                onSelect={this.handleTabSelect}
                activeKey={this.state.activeKey}
                defaultActiveKey={this.state.latestTabKey}
                id="homeposthnav"
                unmountOnExit={true}
            >
                <div className="posthnavtab">
                    <div className="mcustHorizMenu">
                        <div className="mcustHorizinn">
                            <Nav variant="pills">
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.latestTabKey} title="Latest">
                                        Latest
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey={this.state.photosTabKey} title="Photos"
                                    >
                                        Photos
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.videosTabKey} title="Videos">
                                        Videos
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.articlesTabKey} title="Blogs">
                                        Articles
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey={this.state.audioTabKey} title="Audio">
                                        Audio
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                    </div>
                    {this.props.projectId &&
                        <a href="javascript:void(0)" className="viewAllAct btn-primary btn" data-toggle="modal" onClick={() => this.checkPostDataConfig()}>
                            <i className="iAddPost" style={{ marginRight: "5px" }} />Post
                        </a>
                    }
                    {this.props.project && this.props.project.project && this.props.project.wallAvailable && this.props.project.project.type !== "JOB" && 
                        <div className="invtButtns microcommfeed mt-2 align-item-end p-0 mb-2 mr-2 d-flex">
                            <Link to={"/project/feeds/" + this.props.project?.slug + "/grid"} className="viewAllAct onlyIcon ml-1">
                                <i className="iGrid1" /> {/*<span>View All Activity</span>*/}
                            </Link>
                        </div>
                    }
                </div>
                <Tab.Content>
                    <Tab.Pane eventKey={this.state.latestTabKey}>
                        <ProjectLatestPostList
                            key={this.state.latestTabKey}
                            projectId={this.props.projectId}
                            userId={this.props.userId}
                            participantList={this.state.participantList}
                            circleAdminList={this.state.circleAdminList}
                            project={this.props.project}
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.photosTabKey}>
                        <ProjectPhotosPostList
                            key={this.state.photosTabKey}
                            projectId={this.props.projectId}
                            userId={this.props.userId}
                            participantList={this.state.participantList}
                            circleAdminList={this.state.circleAdminList}
                            project={this.props.project}
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.videosTabKey}>
                        <ProjectVideoPostList
                            key={this.state.videosTabKey}
                            projectId={this.props.projectId}
                            userId={this.props.userId}
                            participantList={this.state.participantList}
                            circleAdminList={this.state.circleAdminList}
                            project={this.props.project}
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.articlesTabKey}>
                        <ProjectArticlePostList
                            key={this.state.articlesTabKey}
                            projectId={this.props.projectId}
                            userId={this.props.userId}
                            participantList={this.state.participantList}
                            circleAdminList={this.state.circleAdminList}
                            project={this.props.project}
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey={this.state.audioTabKey}>
                        <ProjectAudioPostList
                            key={this.state.audioTabKey}
                            projectId={this.props.projectId}
                            userId={this.props.userId}
                            participantList={this.state.participantList}
                            circleAdminList={this.state.circleAdminList}
                            project={this.props.project}
                        />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        postCreationResponse:
            state.postReducer && state.postReducer.postCreationResult.value,
    };
};

export default connect(mapStateToProps)(ProjectPostNavBar);